"use client";

import { useShowLicenseRequiredBadge } from "@/app/hooks/useLicenseRequiredBadge";
import Badge from "@/components/design-system/badge";
import IdLicenseIcon from "public/next-public/common/icons/id-license-icon.svg";

/**
 * "License Required" badge, shown only to shoppers who cannot yet buy the product:
 * it renders nothing once the account holds a valid license.
 *
 * Call sites whose badges sit in a conditional container should gate that container with
 * `useShowLicenseRequiredBadge` as well, so it collapses rather than leaving empty gap.
 */
function LicenseRequiredBadge({ licenseIsRequired = true }: LicenseRequiredBadgeProps) {
  const show = useShowLicenseRequiredBadge(licenseIsRequired);
  if (!show) {
    return null;
  }

  return (
    <Badge
      label="License Required"
      color="gray"
      size="small"
      strong={false}
      icon={<IdLicenseIcon width={15} height={12} aria-hidden />}
      tooltip={TOOLTIP_TEXT}
      tooltipPlacement="below"
    />
  );
}

export default LicenseRequiredBadge;

interface LicenseRequiredBadgeProps {
  /** Whether the product itself requires a license. Defaults to true for call sites that already gated. */
  licenseIsRequired?: boolean;
}

const TOOLTIP_TEXT = "You must have a Dental License on your Net32 account to purchase this item.";
